import styled from 'styled-components';
import { color } from 'styles/settings';
import { NameTextInput } from 'routes/surface/components/node-modal-form/style';
import { size, font } from 'styles/settings/typography';
import { normalize } from 'utils/styles';

export const Container = styled.div`
  background-color: ${color.neutral.white};
  max-width: 960px;
  width: 60%;
  margin: auto;
  padding: 20px;
  border-radius: 10px;
  @media all and (max-width: 1200px) {
    width: 80%;
  }
`;

export const UploadFormWrapper = styled.div`
  * {
    max-width: none;
  }
  height: 550px;
  width: auto;
  overflow: hidden;
  margin: 0 30px;

  ${NameTextInput} {
    color: ${color.neutral.plainBlack};
    ${font.title.bold};
    font-size: ${normalize(size.xxxl)};
    height: 81px;
    text-align: left;
    width: 100%;
    margin-bottom: 10px;

    flex: none;
  }
`;
